import React, { useState } from "react";
import { Box } from "@mui/material";
import CourtEventTypeForm from "./Form";
import { allCourtEventTypes } from "../../../../data/Queries/SetupManagement/SystemSetupQueries";
import { caseManagementUrl } from "../../../../config";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";

const base_url = caseManagementUrl.uri;

const CourtEventTypeColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "eventType", headerName: "Event Type", flex: 1.5 },
];

const actions = {
  entity: "Court Event Types",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  }, 
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
  },
  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
};

function CourtEventType() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Court Event Types"
          subtitle="Manage Court Event Types"
          columns={CourtEventTypeColumns}
          FormComponent={CourtEventTypeForm}
          query={allCourtEventTypes}
          base_url={base_url}
          actions={actions}
        />
      </>
    </Box>
  );
}

export default CourtEventType;